/**
 * Normaliza UID do discador (CPF) para comparação/armazenamento.
 * Mantém zeros à esquerda — CPF pode começar com 0.
 *
 * @param {string|number|null|undefined} uid
 * @returns {string}
 */
export function normalizeDialerUid(uid) {
  const digits = String(uid ?? '').replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  return digits.padStart(11, '0').slice(-11);
}

/**
 * Agora RTC / agora-access-token: UID positivo até 2^31-1.
 * CPF 11 dígitos estoura uint32/int32 e quebra join/token.
 * Zeros à esquerda só saem aqui porque o Agora exige UID numérico
 *
 * @param {string|number|null|undefined} uid
 * @returns {number}
 */
export function toAgoraUid(uid) {
  const digits = String(uid ?? '').replace(/\D/g, '');
  if (!digits) {
    return 0;
  }

  const numeric = digits.replace(/^0+/, '') || '0';
  const MAX_SAFE = 2147483647; // 2^31 - 1
  let n = Number(BigInt(numeric) % BigInt(MAX_SAFE));
  if (n === 0) {
    n = 1;
  }
  return n;
}
